import { session } from '@openhouse-engineers/oh-js-utils/lib/utils/session'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Modal } from 'react-responsive-modal'

import { QRCode } from 'components/Artefacts/IframeWhiteboard/QRCode'
import { accessTokenHelper } from 'helpers/token'
import { updateQRCodeInfo } from 'services/apis/user'
import { getWhiteboardCode } from 'services/apis/whiteboard'
import { SECONDARY_DEVICE } from 'services/webSockets/roomState/constants'
import { dispatchSetWhiteboarUrl } from 'store/dispatcher'
import { _roomName } from 'store/selectors/Room'
import { _userType } from 'store/selectors/User'
import { _roomStateMsgData } from 'store/selectors/WebSocket'
import { _whiteboardUrl } from 'store/selectors/Whiteboard'

import {
    Container,
    Heading,
    HeadingBorder,
    QRCodeInstruction,
    QRCodeContainer,
    Instruction,
    LeftLine,
    Text,
    RightLine,
} from './styles'

const modalStyle = {
    modal: {
        padding: '0',
        borderRadius: '8px',
    },
    closeButton: {
        width: 20,
        height: 28,
        top: 16,
        right: 28,
    },
}

const Connect = ({
    isWhiteboardModesListOpen,
    isConnectToTabletModalOpen,
    toggleWhiteboardModesListOpen,
    toggleConnectToTabletModalOpen,
}) => {
    const sessionId = session.get()
    const roomName = useSelector(_roomName)
    const userType = useSelector(_userType)
    const accessToken = accessTokenHelper.get()
    const data = useSelector(_roomStateMsgData)
    const whiteboardUrl = useSelector(_whiteboardUrl)

    const toggleModalState = () => toggleConnectToTabletModalOpen()

    const toggleWhiteboardModesListState = () => toggleWhiteboardModesListOpen()

    useEffect(() => {
        if (data === SECONDARY_DEVICE && isConnectToTabletModalOpen) {
            toggleModalState()
            toggleWhiteboardModesListState()
        } else if (data === SECONDARY_DEVICE && isWhiteboardModesListOpen) {
            toggleWhiteboardModesListState()
        }
    }, [data, isConnectToTabletModalOpen, isWhiteboardModesListOpen])

    useEffect(() => {
        ;(async function generateQRCode() {
            const response = await getWhiteboardCode(roomName)
            const getRequestId = await updateQRCodeInfo({
                accessToken,
                roomName,
                sessionId,
                whiteboardCode: response.data.whiteboard_code,
                userType,
            })
            const whiteboardUrl = `${process.env.REACT_APP_WHITEBOARD_URL}?requestId=${getRequestId.data}`
            dispatchSetWhiteboarUrl(whiteboardUrl)
        })()
    }, [accessToken, roomName, sessionId, userType])

    return (
        <Modal
            open={isConnectToTabletModalOpen}
            onClose={toggleModalState}
            styles={modalStyle}
            center
        >
            <Container>
                <Heading>Connect to Whiteboard</Heading>
                <HeadingBorder></HeadingBorder>
                <QRCodeInstruction>Scan QR Code</QRCodeInstruction>
                <QRCodeContainer>
                    {whiteboardUrl && (
                        <QRCode text={whiteboardUrl} size={'200'} />
                    )}
                </QRCodeContainer>

                <LeftLine />
                <Text>OR</Text>
                <RightLine />

                <Instruction>
                    If the whiteboard is open on your device, click the play
                    button to start presenting again.
                </Instruction>
            </Container>
        </Modal>
    )
}

export default Connect
